// import React, { useEffect, useState } from "react";
// import PropertyOwnerNavbar from "./PropertyOwnerNavbar";
// import axios  from "axios";
// // import OwnerFooter from "../components/OwnerFooter";




// const API_BASE = "https://api.propertygalleria.in/master/api";

// const MyProperties = () => {

//   // const properties = [
//   //   {
//   //     id: 1,
//   //     title: "Elite Villa",
//   //     price: "₹20,000,000",
//   //     size: "2500 sq ft",
//   //     agent: "Agent A",
//   //     image:
//   //       "https://images.unsplash.com/photo-1600607687644-c7171b42498f"
//   //   }
//   // ];  handling_agent_id
//    const user = JSON.parse(localStorage.getItem("user"));
//    console.log('this is user',user)

//   const [properties, setProjects] = useState([]);
//   /* ========== FETCH PROJECTS ========== */
//   const fetchProjects = async () => {
//     try {
//       const res = await axios.get(`${API_BASE}/get/projects`);
//       console.log('this is res',res)
//              const   filter = res.data.filter(po=> po.user_id === user.id)
//       //const filteredResults = res.data.filter(po => po.user_id === user.id);

//       setProjects(filter);
//     } catch (err) {
//       console.error(err);
//       alert("Failed to load projects");
//     }
//   };

//   useEffect(() => {
//     fetchProjects();
//   }, []);

//   return (
//     <>
//       <PropertyOwnerNavbar />
//       <div style={{ padding: 20, paddingBottom: 120, marginTop: '5%' }}>

//         <h2>My Properties</h2>

//         {properties.map(p => (
//           <div key={p.id} style={{
//             marginTop: 20,
//             background: "#fff",
//             borderRadius: 16,
//             overflow: "hidden",
//             boxShadow: "0 6px 20px rgba(0,0,0,0.08)"
//           }}>
//             <img
//               src={p.property_images}
//               alt=""
//               style={{
//                 width: "100%",
//                 height: 260,
//                 objectFit: "cover"
//               }}
//             />

//             <div style={{ padding: 15 }}>
//               <h3>{p.title}</h3>
//               <p style={{ color: "#8a2d5d" }}>{p.price}</p>
//               <p>{p.area}</p>
//               <p>Agent: {p.agent}</p>
//             </div>
//           </div>
//         ))}

//         {/* <OwnerFooter /> */}
//       </div>
//     </>
//   );
// };

// export default MyProperties;


// import React, { useEffect, useState } from "react";
// import PropertyOwnerNavbar from "./PropertyOwnerNavbar";
// import axios from "axios";

// const API_BASE = "https://api.propertygalleria.in/master/api";

// const MyProperties = () => {
//   const user = JSON.parse(localStorage.getItem("user"));

//   const [properties, setProjects] = useState([]);

//   const fetchProjects = async () => {
//     try {
//       const res = await axios.get(`${API_BASE}/get/projects`);

//       const filter = res.data.filter(
//         po => Number(po.user_id) === Number(user.id)
//       );

//       setProjects(filter);
//     } catch (err) {
//       console.error(err);
//       alert("Failed to load projects");
//     }
//   };

//   useEffect(() => {
//     fetchProjects();
//   }, []);

//   const formatPrice = price =>
//     Number(price).toLocaleString("en-IN");

//   return (
//     <>
//       <PropertyOwnerNavbar />

//       <div style={{
//         padding: 20,
//         paddingBottom: 120,
//         marginTop: "5%",
//         maxWidth: 1200,
//         marginInline: "auto"
//       }}>
//         <h2 style={{ marginBottom: 20 }}>My Properties</h2>

//         {properties.map(p => (
//           <div
//             key={p.id}
//             style={{
//               marginBottom: 30,
//               background: "#fff",
//               borderRadius: 18,
//               overflow: "hidden",
//               boxShadow: "0 10px 30px rgba(0,0,0,0.08)"
//             }}
//           >
//             {/* Image Scroll */}
//             <div
//               style={{
//                 display: "flex",
//                 overflowX: "auto",
//                 scrollSnapType: "x mandatory"
//               }}
//             >
//               {p.property_images?.map((img, i) => (
//                 <img
//                   key={i}
//                   src={img}
//                   alt=""
//                   style={{
//                     width: "100%",
//                     minWidth: "100%",
//                     height: 280,
//                     objectFit: "cover",
//                     scrollSnapAlign: "start"
//                   }}
//                 />
//               ))}
//             </div>

//             {/* Details */}
//             <div style={{ padding: 18 }}>
//               <div style={{
//                 display: "flex",
//                 justifyContent: "space-between",
//                 flexWrap: "wrap"
//               }}>
//                 <h3 style={{ margin: 0 }}>{p.title}</h3>

//                 <span style={{
//                   background:
//                     p.status === "Approved"
//                       ? "#e6f7ee"
//                       : "#fff4e5",
//                   color:
//                     p.status === "Approved"
//                       ? "#0f9d58"
//                       : "#d97706",
//                   padding: "4px 10px",
//                   borderRadius: 20,
//                   fontSize: 12,
//                   fontWeight: 600
//                 }}>
//                   {p.status}
//                 </span>
//               </div>

//               <p style={{ color: "#8a2d5d", fontWeight: 600 }}>
//                 ₹ {formatPrice(p.price)}
//               </p>

//               <p style={{ color: "#555" }}>
//                 📍 {p.location}
//               </p>

//               <p style={{ color: "#555" }}>
//                 📐 {p.area} sq ft • {p.category}
//               </p>

//               <p style={{
//                 color: "#666",
//                 marginTop: 8,
//                 lineHeight: 1.4
//               }}>
//                 {p.description}
//               </p>
//             </div>
//           </div>
//         ))}
//       </div>
//     </>
//   );
// };

// export default MyProperties;



// import React, { useEffect, useState } from "react";
// import PropertyOwnerNavbar from "./PropertyOwnerNavbar";
// import axios from "axios";

// const API_BASE = "https://api.propertygalleria.in/master/api";

// const MyProperties = () => {
//   const user = JSON.parse(localStorage.getItem("user"));
//   const [properties, setProjects] = useState([]);

//   const fetchProjects = async () => {
//     try {
//       const res = await axios.get(`${API_BASE}/get/projects`);

//       const filter = res.data.filter(
//         po => Number(po.user_id) === Number(user.id)
//       );

//       setProjects(filter);
//     } catch (err) {
//       alert("Failed to load projects");
//     }
//   };

//   useEffect(() => {
//     fetchProjects();
//   }, []);

//   /* ---------- group by category ---------- */
//   const grouped = properties.reduce((acc, item) => {
//     const cat = item.category || "Others";
//     if (!acc[cat]) acc[cat] = [];
//     acc[cat].push(item);
//     return acc;
//   }, {});

//   const formatPrice = price =>
//     Number(price).toLocaleString("en-IN");

//   return (
//     <>
//       <PropertyOwnerNavbar />

//       <div
//         style={{
//           padding: 20,
//           paddingBottom: 120,
//           marginTop: "5%",
//           maxWidth: 1400,
//           marginInline: "auto"
//         }}
//       >
//         <h2>My Properties</h2>

//         {Object.keys(grouped).map(category => (
//           <div key={category} style={{ marginTop: 30 }}>
//             {/* Category Title */}
//             <h3 style={{ marginBottom: 15 }}>
//               {category}
//             </h3>

//             {/* Grid */}
//             {/* <div
//               style={{
//                 display: "grid",
//                 gap: 20,
//                 gridTemplateColumns:
//                   "repeat(auto-fit, minmax(300px, 1fr))"
//               }}
//             > */}
//             <div
//               style={{
//                 display: "grid",
//                 gap: 20,
//                 justifyContent:
//                   grouped[category].length === 1 ? "center" : "stretch",
//                 gridTemplateColumns:
//                   grouped[category].length === 1
//                     ? "minmax(300px, 500px)"
//                     : "repeat(auto-fit, minmax(300px, 1fr))"
//               }}
//             >

//               {grouped[category].map(p => (
//                 <div
//                   key={p.id}
//                   style={{
//                     background: "#fff",
//                     borderRadius: 16,
//                     overflow: "hidden",
//                     boxShadow:
//                       "0 6px 20px rgba(0,0,0,0.08)"
//                   }}
//                 >
//                   {/* Image Scroll */}
//                   <div
//                     style={{
//                       display: "flex",
//                       overflowX: "auto",
//                       scrollSnapType: "x mandatory"
//                     }}
//                   >
//                     {p.property_images?.map((img, i) => (
//                       <img
//                         key={i}
//                         src={img}
//                         alt=""
//                         style={{
//                           width: "100%",
//                           minWidth: "100%",
//                           height: 220,
//                           objectFit: "cover",
//                           scrollSnapAlign: "start"
//                         }}
//                       />
//                     ))}
//                   </div>

//                   {/* Info */}
//                   <div style={{ padding: 15 }}>
//                     <h4>{p.title}</h4>

//                     <p
//                       style={{
//                         color: "#8a2d5d",
//                         fontWeight: 600
//                       }}
//                     >
//                       ₹ {formatPrice(p.price)}
//                     </p>

//                     <p style={{ color: "#555" }}>
//                       📍 {p.location}
//                     </p>

//                     <p style={{ color: "#555" }}>
//                       📐 {p.area} sq ft
//                     </p>

//                     {/* <span
//                       style={{
//                         background:
//                           p.status === "Approved"
//                             ? "#e6f7ee"
//                             : "#fff4e5",
//                         color:
//                           p.status === "Approved"
//                             ? "#0f9d58"
//                             : "#d97706",
//                         padding: "3px 10px",
//                         borderRadius: 20,
//                         fontSize: 12
//                       }}
//                     >
//                       {p.status}
//                     </span> */}

//                     <span
//                       style={{
//                         background:
//                           p.status === "Sold"
//                             ? "#d1fae5"
//                             : p.status === "Approved"
//                               ? "#ecfdf5"
//                               : "#fff7ed",
//                         color:
//                           p.status === "Sold"
//                             ? "#059669"
//                             : p.status === "Approved"
//                               ? "#16a34a"
//                               : "#ea580c",
//                         padding: "4px 12px",
//                         borderRadius: 20,
//                         fontSize: 12,
//                         fontWeight: 600
//                       }}
//                     >
//                       {p.status}
//                     </span>

//                   </div>
//                 </div>
//               ))}
//             </div>
//           </div>
//         ))}
//       </div>
//     </>
//   );
// };

// export default MyProperties;



// import React, { useEffect, useState } from "react";
// import PropertyOwnerNavbar from "./PropertyOwnerNavbar";
// import axios from "axios";
// import Modal from "react-modal";
// import { X } from "lucide-react";


// const API_BASE = "https://api.propertygalleria.in/master/api";

// Modal.setAppElement("#root");

// const MyProperties = () => {
//   const user = JSON.parse(localStorage.getItem("user"));
//   const [properties, setProjects] = useState([]);

//   const [modalOpen, setModalOpen] = useState(false);
//   const [editingProperty, setEditingProperty] = useState(null);
//   const [form, setForm] = useState({});

//   /* ---------- fetch ---------- */
//   const fetchProjects = async () => {
//     const res = await axios.get(`${API_BASE}/get/projects`);

//     const filter = res.data.filter(
//       po => Number(po.user_id) === Number(user.id)
//     );

//     setProjects(filter);
//   };

//   useEffect(() => {
//     fetchProjects();
//   }, []);

//   /* ---------- group ---------- */
//   const grouped = properties.reduce((acc, item) => {
//     const cat = item.category || "Others";
//     if (!acc[cat]) acc[cat] = [];
//     acc[cat].push(item);
//     return acc;
//   }, {});

//   const formatPrice = price =>
//     Number(price).toLocaleString("en-IN");

//   /* ---------- open modal ---------- */
//   const openEdit = (property) => {
//     setEditingProperty(property);
//     setForm({
//       title: property.title,
//       location: property.location,
//       price: property.price,
//       area: property.area,
//       description: property.description,
//       category: property.category
//     });
//     setModalOpen(true);
//   };

//   const update = (k, v) =>{
//      setForm(form => ({ ...form, [k]: v }));
//   }
//   /* ---------- submit edit ---------- */
//   const handleUpdate = async () => {
//     try {
//       await axios.put(
//         `${API_BASE}/update/project/${editingProperty.id}`,
//         form
//       );

//       alert("Updated successfully");
//       setModalOpen(false);
//       fetchProjects();
//     } catch {
//       alert("Update failed");
//     }
//   };

//   /* ---------- reusable input ---------- */
//   const Input = ({ label, value, onChange }) => (
//     <div style={{ marginBottom: 14 }}>
//       <label>{label}</label>
//       <input
//         value={value || ""}
//         onChange={onChange}
//         style={{
//           width: "100%",
//           padding: 12,
//           borderRadius: 10,
//           border: "1px solid #ddd",
//           marginTop: 5
//         }}
//       />
//     </div>
//   );

//   return (
//     <>
//       <PropertyOwnerNavbar />

//       <div style={{
//         padding: 20,
//         paddingBottom: 120,
//         marginTop: "5%",
//         maxWidth: 1400,
//         marginInline: "auto"
//       }}>
//         <h2>My Properties</h2>

//         {Object.keys(grouped).map(category => (
//           <div key={category} style={{ marginTop: 30 }}>
//             <h3>{category}</h3>

//             <div style={{
//               display: "grid",
//               gap: 20,
//               justifyContent:
//                 grouped[category].length === 1
//                   ? "center"
//                   : "stretch",
//               gridTemplateColumns:
//                 grouped[category].length === 1
//                   ? "minmax(300px,500px)"
//                   : "repeat(auto-fit,minmax(300px,1fr))"
//             }}>
//               {grouped[category].map(p => (
//                 <div key={p.id}
//                   style={{
//                     background: "#fff",
//                     borderRadius: 16,
//                     overflow: "hidden",
//                     boxShadow:
//                       "0 6px 20px rgba(0,0,0,0.08)",
//                     position: "relative"
//                   }}>

//                   {/* EDIT BADGE */}
//                   {!modalOpen && (
//                     <button
//                       onClick={() => openEdit(p)}
//                       style={{
//                         position: "absolute",
//                         top: 10,
//                         left: 10,
//                         background: "#8a2d5d",
//                         color: "#fff",
//                         border: "none",
//                         padding: "5px 12px",
//                         borderRadius: 20,
//                         cursor: "pointer",
//                         fontSize: 12,
//                         zIndex: 10
//                       }}
//                     >
//                       ✏ Edit
//                     </button>
//                   )}

//                   {/* Images */}
//                   <div style={{
//                     display: "flex",
//                     overflowX: "auto"
//                   }}>
//                     {p.property_images?.map((img, i) => (
//                       <img
//                         key={i}
//                         src={img}
//                         alt=""
//                         style={{
//                           width: "100%",
//                           minWidth: "100%",
//                           height: 220,
//                           objectFit: "cover"
//                         }}
//                       />
//                     ))}
//                   </div>

//                   {/* Info */}
//                   <div style={{ padding: 15 }}>
//                     <h4>{p.title}</h4>

//                     <p style={{
//                       color: "#8a2d5d",
//                       fontWeight: 600
//                     }}>
//                       ₹ {formatPrice(p.price)}
//                     </p>

//                     <p>📍 {p.location}</p>
//                     <p>📐 {p.area} sq ft</p>

//                     <span style={{
//                       background:
//                         p.status === "Sold"
//                           ? "#d1fae5"
//                           : p.status === "Approved"
//                             ? "#ecfdf5"
//                             : "#fff7ed",
//                       color:
//                         p.status === "Sold"
//                           ? "#059669"
//                           : p.status === "Approved"
//                             ? "#16a34a"
//                             : "#ea580c",
//                       padding: "4px 12px",
//                       borderRadius: 20,
//                       fontSize: 12
//                     }}>
//                       {p.status}
//                     </span>
//                   </div>
//                 </div>
//               ))}
//             </div>
//           </div>
//         ))}
//       </div>

//       {/* ================= MODAL ================= */}
//       <Modal
//         isOpen={modalOpen}
//         onRequestClose={() => setModalOpen(false)}
//         style={{
//           content: {
//             maxWidth: 600,
//             margin: "auto",
//             borderRadius: 16,
//             marginTop: '5%',
//             padding: "24px",
//             inset: "40px",
//             position: "relative"
//           }
//         }}
//       >
//         {/* Close Button */}
//         {/* <button
//     onClick={() => setModalOpen(false)}
//     style={{
//       position: "absolute",
//       top: 10,
//       right: 12,
//       background: "#f3f4f6",
//       border: "none",
//       borderRadius: "50%",
//       width: 32,
//       height: 32,
//       cursor: "pointer",
//       fontSize: 18,
//       fontWeight: "bold",
//       lineHeight: "32px"
//     }}
//   >
//     ✕
//   </button> */}

//         <button
//           onClick={() => setModalOpen(false)}
//           style={{
//             position: "absolute",
//             top: 12,
//             right: 12,
//             background: "#f3f4f6",
//             border: "none",
//             borderRadius: "50%",
//             width: 34,
//             height: 34,
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "center",
//             cursor: "pointer"
//           }}
//         >
//           <X size={18} />
//         </button>

//         <h2>Edit Property</h2>

//         <Input
//           label="Title"
//           value={form.title}
//           onChange={(e) => update("title", e.target.value)}
//         />

//         <Input
//           label="Location"
//           value={form.location}
//           onChange={(e) => update("location", e.target.value)}
//         />

//         <Input
//           label="Price"
//           value={form.price}
//           onChange={(e) => update("price", e.target.value)}
//         />

//         <Input
//           label="Area"
//           value={form.area}
//           onChange={(e) => update("area", e.target.value)}
//         />

//         <textarea
//           rows={4}
//           value={form.description || ""}
//           onChange={(e) =>
//             update("description", e.target.value)
//           }
//           style={{
//             width: "100%",
//             padding: 12,
//             borderRadius: 10,
//             border: "1px solid #ddd",
//             marginTop: 10
//           }}
//         />

//         <button
//           onClick={handleUpdate}
//           style={{
//             marginTop: 20,
//             width: "100%",
//             padding: 14,
//             borderRadius: 12,
//             border: "none",
//             background: "#8a2d5d",
//             color: "#fff",
//             cursor: "pointer"
//           }}
//         >
//           Update Property
//         </button>
//       </Modal>
//     </>
//   );
// };

// export default MyProperties;



import React, { useEffect, useState } from "react";
import PropertyOwnerNavbar from "./PropertyOwnerNavbar";
import axios from "axios";
import Modal from "react-modal";
import { X } from "lucide-react";
import { City } from "country-state-city";

const API_BASE = "https://api.propertygalleria.in/master/api";
const CATEGORY_API = "http://localhost:4001";

Modal.setAppElement("#root");

/* ================= Reusable Input ================= */
const Input = ({ label, value, onChange }) => (
  <div style={{ marginBottom: 14 }}>
    <label style={{ fontSize: 14, fontWeight: 500 }}>{label}</label>
    <input
      value={value || ""}
      onChange={onChange}
      style={{
        width: "100%",
        padding: 12,
        borderRadius: 10,
        border: "1px solid #ddd",
        marginTop: 5
      }}
    />
  </div>
);

const MyProperties = () => {
  const user = JSON.parse(localStorage.getItem("user"));

  const [properties, setProjects] = useState([]);

  /* Dropdown states */
  const [zones, setZones] = useState([]);
  const [categories, setCategories] = useState([]);
  const [cities, setCities] = useState([]);

  /* Modal state */
  const [modalOpen, setModalOpen] = useState(false);
  const [editingProperty, setEditingProperty] = useState(null);

  const [form, setForm] = useState({});

  /* ================= Fetch Properties ================= */
  const fetchProjects = async () => {
    try {
      const res = await axios.get(`${API_BASE}/get/projects`);

      const filter = res.data.filter(
        po => Number(po.user_id) === Number(user.id)
      );

      setProjects(filter);
    } catch {
      alert("Failed to load properties");
    }
  };

  /* ================= Fetch Dropdown Data ================= */
  useEffect(() => {
    fetchProjects();

    axios.get(`${API_BASE}/api/zones`)
      .then(res => setZones(res.data));

    axios.get(`${API_BASE}/get/property_categories`)
      .then(res => setCategories(res.data));

    const indiaCities = City.getCitiesOfCountry("IN")
      .map(c => c.name)
      .sort();

    setCities(indiaCities);
  }, []);

  /* ================= Group by Category ================= */
  const grouped = properties.reduce((acc, item) => {
    const cat = item.category || "Others";
    if (!acc[cat]) acc[cat] = [];
    acc[cat].push(item);
    return acc;
  }, {});

  const formatPrice = price =>
    Number(price || 0).toLocaleString("en-IN");

  /* ================= Open Edit Modal ================= */
  const openEdit = (property) => {
    setEditingProperty(property);

    setForm({
      zone_code: property.zone_code,
      zone_desc: property.zone_desc,
      title: property.title,
      location: property.location,
      price: property.price,
      area: property.area,
      description: property.description,
      category: property.category
    });

    setModalOpen(true);
  };

  const update = (k, v) =>
    setForm(prev => ({ ...prev, [k]: v }));

  /* ================= Submit Update ================= */
  const handleUpdate = async () => {
    try {
      await axios.put(
        `${API_BASE}/update/owner/properties/${editingProperty.id}`,
        form
      );

      alert("Updated successfully");
      setModalOpen(false);
      fetchProjects();
    } catch {
      alert("Update failed");
    }
  };

  return (
    <>
      <PropertyOwnerNavbar />

      <div style={{
        padding: 20,
        paddingBottom: 120,
        marginTop: "5%",
        maxWidth: 1400,
        marginInline: "auto"
      }}>
        <h2>My Properties</h2>

        {Object.keys(grouped).map(category => (
          <div key={category} style={{ marginTop: 30 }}>
            <h3>{category}</h3>

            <div style={{
              display: "grid",
              gap: 20,
              justifyContent:
                grouped[category].length === 1
                  ? "center"
                  : "stretch",
              gridTemplateColumns:
                grouped[category].length === 1
                  ? "minmax(300px,500px)"
                  : "repeat(auto-fit,minmax(300px,1fr))"
            }}>
              {grouped[category].map(p => (
                <div
                  key={p.id}
                  style={{
                    background: "#fff",
                    borderRadius: 16,
                    overflow: "hidden",
                    boxShadow: "0 6px 20px rgba(0,0,0,0.08)",
                    position: "relative"
                  }}
                >

                  {/* Edit badge */}
                  {/* {!modalOpen && (
                    <button
                      onClick={() => openEdit(p)}
                      style={{
                        position: "absolute",
                        top: 10,
                        left: 10,
                        background: "#8a2d5d",
                        color: "#fff",
                        border: "none",
                        padding: "5px 12px",
                        borderRadius: 20,
                        cursor: "pointer",
                        fontSize: 12,
                        zIndex: 10
                      }}
                    >
                      ✏ Edit
                    </button>
                  )} */}
                  {!modalOpen && (
                    <button
                      onClick={() => alert("Please contact the admin to edit the details")}
                      style={{
                        position: "absolute",
                        top: 10,
                        left: 10,
                        background: "#8a2d5d",
                        color: "#fff",
                        border: "none",
                        padding: "5px 12px",
                        borderRadius: 20,
                        cursor: "pointer",
                        fontSize: 12,
                        zIndex: 10
                      }}
                    >
                      ✏ Edit
                    </button>
                  )}


                  {/* Images */}
                  <div style={{
                    display: "flex",
                    overflowX: "auto"
                  }}>
                    {p.property_images?.map((img, i) => (
                      <img
                        key={i}
                        src={img}
                        alt=""
                        style={{
                          width: "100%",
                          minWidth: "100%",
                          height: 220,
                          objectFit: "cover"
                        }}
                      />
                    ))}
                  </div>

                  {/* Info */}
                  <div style={{ padding: 15 }}>
                    <h4>{p.title}</h4>

                    <p style={{
                      color: "#8a2d5d",
                      fontWeight: 600
                    }}>
                      ₹ {formatPrice(p.price)}
                    </p>

                    <p>📍 {p.location}</p>
                    <p>📐 {p.area} sq ft</p>

                    <span style={{
                      background:
                        p.status === "Sold"
                          ? "#d1fae5"
                          : p.status === "Approved"
                            ? "#ecfdf5"
                            : "#fff7ed",
                      color:
                        p.status === "Sold"
                          ? "#059669"
                          : p.status === "Approved"
                            ? "#16a34a"
                            : "#ea580c",
                      padding: "4px 12px",
                      borderRadius: 20,
                      fontSize: 12,
                      fontWeight: 600
                    }}>
                      {p.status}
                    </span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>

      {/* ================= Modal ================= */}
      <Modal
        isOpen={modalOpen}
        onRequestClose={() => setModalOpen(false)}
        style={{
          content: {
            maxWidth: 600,
            margin: "auto",
            borderRadius: 16,
            marginTop: "5%",
            padding: 24,
            inset: "40px",
            position: "relative"
          }
        }}
      >
        {/* Close button */}
        <button
          onClick={() => setModalOpen(false)}
          style={{
            position: "absolute",
            top: 12,
            right: 12,
            background: "#f3f4f6",
            border: "none",
            borderRadius: "50%",
            width: 34,
            height: 34,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer"
          }}
        >
          <X size={18} />
        </button>

        <h2>Edit Property</h2>

        {/* Zone */}
        <select
          value={form.zone_code || ""}
          onChange={(e) => {
            const zone = zones.find(
              z => z.zone_code === e.target.value
            );
            update("zone_code", zone.zone_code);
            update("zone_desc", zone.zone_desc);
          }}
          style={{ width: "100%", padding: 12, marginBottom: 12 }}
        >
          <option>Select Zone</option>
          {zones.map(z => (
            <option key={z.id} value={z.zone_code}>
              {z.zone_desc}
            </option>
          ))}
        </select>

        <Input
          label="Title"
          value={form.title}
          onChange={(e) => update("title", e.target.value)}
        />

        {/* City */}
        <select
          value={form.location || ""}
          onChange={(e) => update("location", e.target.value)}
          style={{ width: "100%", padding: 12, marginBottom: 12 }}
        >
          <option>Select City</option>
          {cities.map((c, i) => (
            <option key={i}>{c}</option>
          ))}
        </select>

        <Input
          label="Price"
          value={form.price}
          onChange={(e) => update("price", e.target.value)}
        />

        <Input
          label="Area"
          value={form.area}
          onChange={(e) => update("area", e.target.value)}
        />

        {/* Category */}
        <select
          value={form.category || ""}
          onChange={(e) => update("category", e.target.value)}
          style={{ width: "100%", padding: 12, marginBottom: 12 }}
        >
          <option>Select Category</option>
          {categories.map(c => (
            <option key={c.id} value={c.category_name}>
              {c.category_name}
            </option>
          ))}
        </select>

        <textarea
          rows={4}
          value={form.description || ""}
          onChange={(e) =>
            update("description", e.target.value)
          }
          style={{
            width: "100%",
            padding: 12,
            borderRadius: 10,
            border: "1px solid #ddd",
            marginTop: 10
          }}
        />

        <button
          onClick={handleUpdate}
          style={{
            marginTop: 20,
            width: "100%",
            padding: 14,
            borderRadius: 12,
            border: "none",
            background: "#8a2d5d",
            color: "#fff",
            cursor: "pointer",
            fontWeight: 600
          }}
        >
          Update Property
        </button>
      </Modal>
    </>
  );
};

export default MyProperties;
